import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { AppShell } from "@/components/shell/AppShell";
import { mfaStepOf, tenantIdOf } from "@/lib/auth";
import { sessionContextQuery } from "@/lib/session";
import { isDemoMode } from "@/lib/supabase";

// Guarded layout for every screen inside the shell.
// Signed out → /login. Two-step sign-in pending → /mfa. Signed in without an
// organization → /onboarding.
// The session is read from local storage, so the guard costs no round-trip.
export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    if (isDemoMode) return;
    const session = await context.auth.getSession();
    if (!session) {
      throw redirect({ to: "/login", search: { redirect: location.href } });
    }
    if (mfaStepOf(session)) {
      throw redirect({ to: "/mfa", search: { redirect: location.href } });
    }
    if (!tenantIdOf(session)) {
      throw redirect({ to: "/onboarding" });
    }
  },
  // Start the shell's single context round-trip in parallel with route code.
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(sessionContextQuery);
  },
  component: AppLayout,
});

function AppLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
